import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/pages/softskills/programs1.jpg")